import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';

/**
 * The selected company id, or '' when there is not one.
 *
 * `src/stores/account` writes the literal string 'null' whenever the account has no company. That
 * is truthy, survives `|| ''`, and passes the `!!value` filter the admin API applies to query
 * params, so it reached the backend as `companyId=null` and came back a 400.
 */
export const currentCompanyId = () => {
  const value = localStorage.getItem(USER_SETTINGS_KEYS.company);
  return !value || value === 'null' || value === 'undefined' ? '' : value;
};